import { render } from "./AppCountrySelect.vue?vue&type=template&id=0bbf9ff6"
import script from "./AppCountrySelect.vue?vue&type=script&lang=ts"
export * from "./AppCountrySelect.vue?vue&type=script&lang=ts"
script.render = render

export default script